import { IndexedDb, IndexedDbKey } from "@/services/indexedDb";

const Value_DoNotShowAgain = true;

export function useOldMarketplaceItemsDialog() {
  const isOpeningAllowed = async () => {
    const storedValue = await IndexedDb.get(IndexedDbKey.DoNotShowOldMarketplaceItemsDialog);
    return storedValue !== Value_DoNotShowAgain;
  };

  const setDoNotShowAgain = async () => {
    return IndexedDb.set(IndexedDbKey.DoNotShowOldMarketplaceItemsDialog, Value_DoNotShowAgain);
  };

  return {
    isOpeningAllowed,
    setDoNotShowAgain,
  };
}
